import { render } from "./SmartZonesPage.vue?vue&type=template&id=510df9db&ts=true"
import script from "./SmartZonesPage.ts?vue&type=script&lang=ts"
export * from "./SmartZonesPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__